import styled from '@emotion/styled';
import Button from '@mui/material/Button';
import { Compose } from 'theme/commonStyled';

export const StyledButton = styled(Button)<{ loading: number }>`
  :disabled {
    ${({ theme, loading, variant }): string =>
      loading === 1
        ? `
           opacity: 0.65;
          `
        : `
           background-color: ${
             !variant?.includes('Text') ? theme.colors.ash40 : 'transparent'
           };
           border-color: ${theme.colors.ash50};
           color: ${theme.colors.ash60} !important;
          `}
  }

  .MuiButton-startIcon {
    margin-left: 0;
    margin-right: 0;
  }
  ${Compose};
`;
